/**
 * ActivationLibraryContentCtrl controller
 * Show subscribers library on activation page
 */

// controller mixins
import { SET_SETTINGS_TYPES } from '../../../app/core/constants'

ActivationLibraryContentCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * ActivationLibraryContentCtrl controller
 *
 * @class ActivationLibraryContentCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:ActivationLibraryContentCtrl
 */
/* @ngInject */
export default function ActivationLibraryContentCtrl ($scope, $uibModal, $http, LibraryContent, subscr) {
  var vm = this

  vm.isFound = false

  /**
   * A constant map that defines the relationships between various library content types.
   */
  vm.LIBRARY_CONTENT_TYPE_MAP = {
    channels: 'CHANNEL',
    'channels-bundles': 'CHANNEL_SET',
    'live-events': 'LIVE_EVENT',
    vods: 'VOD',
    'vod-bundles': 'VOD_SET',
    'tv-shows': 'TV_SHOW',
    seasons: 'SEASON',
    episodes: 'EPISODE',
    'tv-show-bundles': 'TV_SHOW_SET',
    'multi-bundles': 'MULTI_SET'
  }

  vm.MONETIZATION_TYPE_MAP = SET_SETTINGS_TYPES

  /**
   * Content for table
   *
   * @type {LibraryContent[]}
   */
  vm.content = []

  /**
   * Current tab from scope
   */
  vm.tabIndex = $scope.data

  /**
   * Current tab name from event 'dispatch: library'
   */
  vm.currentTabName = ''

  $scope.$on('dispatch: library', function ($event, currentTabName) {
    vm.currentTabName = currentTabName

    $scope.$broadcast('refreshTable')
  })

  /**
   * Some of the data that can be used in directives
   */
  vm.shareScope = {}

  /**
   * Get Library Content from backend
   *
   * @memberof mwApp/subscribers.controller:ActivationLibraryContentCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getContent = function (tableState) {
    if (vm.currentTabName === vm.tabIndex) {
      const contentType = vm.LIBRARY_CONTENT_TYPE_MAP[vm.currentTabName]
      LibraryContent.loadContent(tableState, { subscriber: subscr, contentType })
        .then(({ content }) => {
          vm.isFound = !!content.length
          vm.content = content
          vm.content.forEach(i => { i.subscriber = subscr })
        })
    }
  }

  /**
   * Delete content
   *
   * @memberof mwApp/subscribers.controller:ActivationLibraryContentCtrl
   */
  vm.delete = function (content) {
    content.subscriber = subscr
    content._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }
}
